import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import RendersIcons from '../componets/RendersIcons'
import { styled } from '@mui/material/styles';
import VesperLogoText from './VesperLogoText';
const CustomListItemText = styled(ListItemText)(({ theme }) => ({
    '& .MuiTypography-root': {
        width: '86%',
        // Aggiungiamo i colori del logo qui sotto
    },
    '& .MuiListItemText-primary': {
        color: '#C5A039', // Oro Vesper Caffè
        textTransform: 'uppercase', // Richiama lo stile del logo
    },
    '& .MuiListItemText-secondary': {
        color: '#FFFFFF', // Descrizione in BIANCO puro
        fontSize: '0.85rem',
        opacity: 0.9,      // Leggera opacità per non renderlo troppo "pesante" rispetto all'oro
        fontStyle: 'italic' // Per richiamare lo stile "Shaken, not stirred"
    }
}));

export default function RenderPage(props) {
    const [menu, setMenujson] = useState(props.pizzas);
    const renderList = (value) => {
        // 1. Controllo di sicurezza iniziale
        if (!value || !Array.isArray(value)) return null;

        // 2. Pulizia e Ordinamento senza localeCompare (usiamo confronto semplice)
        const sortedList = value.filter(item => item !== null && item !== undefined);
        /*const sortedList = [...value]
            .filter(item => item !== null && item !== undefined)
            .sort((a, b) => {
                const typeA = (a.type || "").toString().toUpperCase();
                const typeB = (b.type || "").toString().toUpperCase();
                if (typeA < typeB) return -1;
                if (typeA > typeB) return 1;
                return 0;
            });
            */

        let lastType = null;
        const finalUI = [];

        // 3. Costruzione della lista
        sortedList.forEach((item, index) => {
            const currentType = (item.type || "ALTRO").toUpperCase();

            // Se cambia il tipo (o è il primo elemento), mettiamo il titolo
            if (currentType !== lastType) {
                lastType = currentType;
                finalUI.push(
                    <Typography
                        key={`header-${currentType}-${index}`}
                        variant="h6"
                        component="div"
                        align="center"
                        color="#C5A039"
                        sx={{ 
                            mt: 4, 
                            mb: 2, 
                            fontWeight: 'bold', 
                            color: "#C5A039",
                            // Queste 3 righe servono per centrare e stringere la linea:
                            width: '80%',
                            mx: 'auto', 
                            borderBottom: '2px solid #C5A039',
                            
                            // Opzionale: aggiungi un po' di padding laterale per non 
                            // far attaccare la linea alle lettere
                            px: 2, 
                            textTransform: 'uppercase',
                            letterSpacing: '2px'
                        }}
                    >
                        {currentType}
                    </Typography>
                );
            }

            // Aggiungiamo l'item
            finalUI.push(
                <ListItem key={`item-${item.id || index}`}
                    secondaryAction={
                        <div id="buttons" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {/* Mostriamo solo il prezzo come testo semplice */}
                            <Typography
                                variant="body1"
                                sx={{
                                    color: "#C5A039",
                                    fontWeight: 'bold',
                                    minWidth: '70px',
                                    textAlign: 'right'
                                }}
                            >
                                {(item.price || 0) + " €"}
                            </Typography>
                            {/*<IconButton onClick={() => addOrLess(index, true)}>
                                <ListItemText
                                    primary={"+ " + (item.price || 0) + " €"}
                                />
                            </IconButton>*/}

                            {/*renderButtonQuantity(item, 'PIZZE', index)*/}
                        </div>
                    }
                >
                    <ListItemAvatar>
                        <RendersIcons title={item.type} />
                    </ListItemAvatar>
                    <CustomListItemText
                        color="#C5A039"
                        primary={item.name}
                        secondary={item.description}
                    />
                </ListItem>
            );
        });

        return finalUI;
    }

    const renderButtonQuantity = (value, titleKey, valueKey) => {
        return (
            <IconButton
                color={value.quantity !== undefined && value.quantity !== 0 ? "success" : "warning"}
                onClick={() => addOrLess(valueKey, false)}>
                <ListItemText
                    primary={value.quantity != null ? value.quantity : 0}
                />
            </IconButton>
        );
    }

    const addOrLess = (index, isAdd) => {
        const updatedMenu = menu.map((dish, i) => {
            if (i !== index) return dish;
            const quantity = dish.quantity ?? 0; // default 0 if undefined
            return {
                ...dish,
                quantity: isAdd
                    ? quantity + 1
                    : Math.max(quantity - 1, 0), // never < 0
            };
        });

        setMenujson(updatedMenu);
        props.setOrder(updatedMenu);
    };


    return (
        <div className="Content-list">
            <VesperLogoText/>
            {renderList(menu)}
        </div>
    );
}